const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = {
  // Get all news posts (public)
  async getNews(limit = null) {
    const url = limit ? `${API_BASE}/news?limit=${limit}` : `${API_BASE}/news`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch news');
    return response.json();
  },

  // Get single news post by slug (public)
  async getNewsPost(slug) {
    const response = await fetch(`${API_BASE}/news/${slug}`);
    if (!response.ok) throw new Error('Post not found');
    return response.json();
  },

  // Admin: Get all news posts (including drafts)
  async adminGetNews(token) {
    const response = await fetch(`${API_BASE}/admin/news`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to fetch news');
    return response.json();
  },

  // Admin: Get single news post by ID
  async adminGetNewsPost(token, id) {
    const response = await fetch(`${API_BASE}/admin/news/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Post not found');
    return response.json();
  },

  // Admin: Create news post
  async createNewsPost(token, data) {
    const response = await fetch(`${API_BASE}/admin/news`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to create post');
    }
    return response.json();
  },

  // Admin: Update news post
  async updateNewsPost(token, id, data) {
    const response = await fetch(`${API_BASE}/admin/news/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to update post');
    }
    return response.json();
  },

  // Admin: Delete news post
  async deleteNewsPost(token, id) {
    const response = await fetch(`${API_BASE}/admin/news/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to delete post');
  },

  // Admin: Login
  async login(password) {
    const response = await fetch(`${API_BASE}/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });
    if (!response.ok) {
      throw new Error('Invalid password');
    }
    return response.json();
  },

  // Admin: Upload image
  async uploadImage(token, file) {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${API_BASE}/admin/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      if (!response.ok) {
        const errorText = await response.text();
        let errorMessage = 'Failed to upload image';
        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorMessage;
        } catch {
          errorMessage = `Upload failed: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }
      return response.json();
    } catch (err) {
      if (err.message.includes('Failed to fetch') || err.message.includes('NetworkError')) {
        throw new Error('Network error - please check your connection');
      }
      throw err;
    }
  },
};

export default api;
